import { Navigate, RouteObject } from "react-router";
import { OutboxGesecInvoiceRoute } from "./outbox/gesec-invoices/[outboxId]/outbox-gesec-invoice-route";
import { OutboxGesecInvoicesRoute } from "./outbox/gesec-invoices/outbox-gesec-invoices-route";

export const invoicesRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="business-central/outbox/gesec-invoices" replace />,
  },
  {
    path: "business-central/outbox",
    element: <Navigate to="gesec-invoices" replace />,
  },
  {
    path: "business-central/outbox/gesec-invoices",
    element: <OutboxGesecInvoicesRoute />,
  },
  {
    path: "business-central/outbox/gesec-invoices/:outboxId",
    element: <OutboxGesecInvoiceRoute />,
  },
];
